import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useOpts } from '../context';
import { useGetLocalizedString } from './useGetLocalizedString';
import { selectExperiments } from '../state/slices/slice-link-params';
import { checkHackyWorkspace } from '../utils/hacky-workspace-customizations';
import getPlatformTypeName from '../consts/platform-types';
var DEFAULT_ICON_SIZE = 16;
var useIntro = function () {
    var getLocalizedString = useGetLocalizedString();
    var experiments = useSelector(selectExperiments);
    var linkTokenPayload = useOpts().linkTokenPayload;
    var orgName = linkTokenPayload.orgName, platformType = linkTokenPayload.platformType;
    var workspaceName = linkTokenPayload.workspaceName;
    var iconColor = useMemo(function () {
        if (checkHackyWorkspace('Flow', workspaceName) ||
            checkHackyWorkspace('Flow Theme Testing', workspaceName) ||
            checkHackyWorkspace('Nassau Financial CU', workspaceName)) {
            return {
                type: 'theme',
                colorLegacy: 'Primary/50',
                colorNext: 'brand/default',
            };
        }
        if (checkHackyWorkspace('Key Bank', workspaceName)) {
            return {
                type: 'theme',
                colorLegacy: 'Primary/70',
                colorNext: 'brand/default',
            };
        }
        return {
            type: 'theme',
            colorLegacy: 'Blue/50',
            colorNext: 'brand/default',
        };
    }, [workspaceName]);
    var defaultTitle = getLocalizedString('USES_PINWHEEL', [
        orgName,
        getLocalizedString(getPlatformTypeName(platformType)),
    ]);
    if (linkTokenPayload.enableBillNavigator) {
        return {
            title: getLocalizedString('BILL_NAVIGATOR_TITLE'),
            iconColor: iconColor,
            rows: [
                {
                    icon: 'billManage',
                    iconSize: DEFAULT_ICON_SIZE,
                    header: getLocalizedString('MANAGE_BILLS'),
                },
                {
                    icon: 'billDetect',
                    iconSize: DEFAULT_ICON_SIZE,
                    header: getLocalizedString('FIND_AND_CANCEL_SUBSCRIPTIONS'),
                },
                {
                    icon: 'billCalendar',
                    iconSize: DEFAULT_ICON_SIZE,
                    header: getLocalizedString('ALERTS_AND_REMINDERS'),
                },
            ],
            showLogo: true,
            includeAndMore: true,
        };
    }
    // https://pinwheel.atlassian.net/browse/CORE-1663
    if (checkHackyWorkspace('Citizens', workspaceName) ||
        checkHackyWorkspace('Citizens Theme Testing', workspaceName)) {
        return {
            title: getLocalizedString('CITIZENS_INTRO_TITLE'),
            headerTextColor: {
                type: 'raw',
                colorPair: {
                    light: '#008555',
                    dark: '#008555',
                },
            },
            iconColor: {
                type: 'raw',
                colorPair: {
                    light: '#008555',
                    dark: '#008555',
                },
            },
            rows: [
                {
                    icon: 'search2',
                    iconSize: 24,
                    header: getLocalizedString('CITIZENS_INTRO_STEP_1_TITLE'),
                    body: [getLocalizedString('CITIZENS_INTRO_STEP_1_TEXT')],
                },
                {
                    icon: 'lock',
                    iconSize: 24,
                    header: getLocalizedString('CITIZENS_INTRO_STEP_2_TITLE'),
                    body: [getLocalizedString('CITIZENS_INTRO_STEP_2_TEXT')],
                },
                {
                    icon: 'certifiedRibbon',
                    iconSize: 24,
                    header: getLocalizedString('CITIZENS_INTRO_STEP_3_TITLE'),
                    body: [getLocalizedString('CITIZENS_INTRO_STEP_3_TEXT')],
                },
            ],
            showLogo: false,
            includeAndMore: false,
        };
    }
    if (checkHackyWorkspace('Redwood CU', workspaceName) ||
        checkHackyWorkspace('Redwood CU Theme Testing', workspaceName)) {
        return {
            title: defaultTitle,
            iconColor: {
                type: 'raw',
                colorPair: {
                    light: '#046A38',
                    dark: '#046A38',
                },
            },
            rows: [
                {
                    icon: 'shieldCheck',
                    iconSize: DEFAULT_ICON_SIZE,
                    header: getLocalizedString('ENCRYPTED_AND_SECURE'),
                    body: [getLocalizedString('YOUR_INFORMATION')],
                },
                {
                    icon: 'userSearch',
                    iconSize: DEFAULT_ICON_SIZE,
                    header: getLocalizedString('ALWAYS_PRIVATE'),
                    body: [getLocalizedString('WILL_NEVER', [orgName])],
                },
                {
                    icon: 'flash',
                    iconSize: DEFAULT_ICON_SIZE,
                    header: getLocalizedString('CONVENIENT_AND_FAST'),
                },
            ],
            showLogo: true,
            includeAndMore: false,
        };
    }
    if (experiments.introScreenLayout) {
        return {
            title: defaultTitle,
            iconColor: iconColor,
            rows: [
                {
                    icon: 'shieldCheck',
                    iconSize: DEFAULT_ICON_SIZE,
                    header: getLocalizedString('ENCRYPTED_AND_PRIVATE'),
                    body: [getLocalizedString('ENCRYPTED_AND_PRIVATE_DETAIL', [orgName])],
                },
                {
                    icon: 'flash',
                    iconSize: DEFAULT_ICON_SIZE,
                    header: getLocalizedString('CONVENIENT_AND_FAST'),
                    body: [
                        getLocalizedString('SWITCH_ALL_OR_PORTION'),
                        checkHackyWorkspace('One Finance', workspaceName)
                            ? ''
                            : getLocalizedString('YOU_WILL_NEED'),
                    ],
                },
            ],
            showLogo: true,
            includeAndMore: false,
        };
    }
    return {
        title: defaultTitle,
        iconColor: iconColor,
        rows: [
            {
                icon: 'shieldCheck',
                iconSize: DEFAULT_ICON_SIZE,
                header: getLocalizedString('ENCRYPTED_AND_SECURE'),
                body: [getLocalizedString('YOUR_INFORMATION')],
            },
            {
                icon: 'userSearch',
                iconSize: DEFAULT_ICON_SIZE,
                header: getLocalizedString('ALWAYS_PRIVATE'),
                body: [getLocalizedString('WILL_NEVER', [orgName])],
            },
            {
                icon: 'flash',
                iconSize: DEFAULT_ICON_SIZE,
                header: getLocalizedString('CONVENIENT_AND_FAST'),
            },
        ],
        showLogo: true,
        includeAndMore: false,
    };
};
export default useIntro;
